/**
 * Initialize video carousel with Splide
 * @param {string} sectionId - The section ID to target
 * @param {Object} options - Configuration options
 * @param {boolean} options.autoplay - Whether carousel should autoplay
 * @param {number} options.autoplaySpeed - Autoplay interval in milliseconds
 * @param {string} options.blockType - Block type ('video' or 'testimonial')
 */
function initVideoCarousel(sectionId, options = {}) {
  const splideElement = document.querySelector(`.video-carousel--${sectionId} .splide`);
  if (!splideElement) return;

  const isTestimonial = options.blockType === 'testimonial';

  const splideConfig = {
    type: 'loop',
    perPage: isTestimonial ? 3 : 5,
    focus: 'center',
    gap: isTestimonial ? '20px' : '15px',
    padding: isTestimonial ? { left: '5%', right: '5%' } : '0',
    pagination: false,
    arrows: false,
    drag: true,
    wheel: false,
    trimSpace: false,
    updateOnMove: true,
    breakpoints: {
      749: {
        perPage: isTestimonial ? 2 : 1,
        gap: isTestimonial ? '15px' : '10px',
        focus: 'center',
        padding: isTestimonial ? { left: '3%', right: '3%' } : '10%',
        drag: true,
        wheel: false,
        trimSpace: false,
        updateOnMove: true,
      },
    },
  };

  if (options.autoplay) {
    splideConfig.autoplay = true;
    splideConfig.interval = options.autoplaySpeed || 3000;
    splideConfig.pauseOnHover = true;
  }

  const splide = new Splide(splideElement, splideConfig);

  function pauseAllVideos() {
    const allVideos = splideElement.querySelectorAll('deferred-media');
    allVideos.forEach((videoElement) => {
      if (videoElement.pauseMedia) {
        videoElement.pauseMedia();
      }
    });
  }

  function playActiveVideo() {
    const activeSlides = splideElement.querySelectorAll('.splide__slide.is-active');
    let activeSlide = null;

    for (let i = 0; i < activeSlides.length; i++) {
      if (!activeSlides[i].classList.contains('splide__slide--clone')) {
        activeSlide = activeSlides[i];
        break;
      }
    }

    if (!activeSlide) {
      const currentIndex = splide.index;
      const allSlides = splideElement.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
      if (allSlides[currentIndex]) {
        activeSlide = allSlides[currentIndex];
      }
    }

    if (!activeSlide) return;

    const videoElement = activeSlide.querySelector('deferred-media');
    if (!videoElement) return;

    if (!videoElement.getAttribute('data-media-loaded')) {
      if (videoElement.showDeferredMedia) {
        videoElement.showDeferredMedia();
      }

      const playVideo = () => {
        if (videoElement.getAttribute('data-media-loaded')) {
          if (videoElement.playMedia) {
            videoElement.playMedia();
          }
        } else {
          requestAnimationFrame(playVideo);
        }
      };
      requestAnimationFrame(playVideo);
    } else {
      if (videoElement.playMedia) {
        videoElement.playMedia();
      }
    }
  }

  splide.on('moved', () => {
    pauseAllVideos();
    playActiveVideo();
  });

  splide.on('active', (slideElement) => {
    pauseAllVideos();

    let targetSlide = slideElement;
    if (slideElement.classList.contains('splide__slide--clone')) {
      const currentIndex = splide.index;
      const allSlides = slideElement.parentElement.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
      if (allSlides[currentIndex]) {
        targetSlide = allSlides[currentIndex];
      }
    }

    const videoElement = targetSlide.querySelector('deferred-media');
    if (!videoElement) return;

    if (!videoElement.getAttribute('data-media-loaded')) {
      if (videoElement.showDeferredMedia) {
        videoElement.showDeferredMedia();
      }

      const playVideo = () => {
        if (videoElement.getAttribute('data-media-loaded')) {
          if (videoElement.playMedia) {
            videoElement.playMedia();
          }
        } else {
          requestAnimationFrame(playVideo);
        }
      };
      requestAnimationFrame(playVideo);
    } else {
      if (videoElement.playMedia) {
        videoElement.playMedia();
      }
    }
  });

  splide.mount();

  const prevButton = document.querySelector(`.video-carousel--${sectionId} .products-carousel__nav-button--prev`);
  const nextButton = document.querySelector(`.video-carousel--${sectionId} .products-carousel__nav-button--next`);

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      splide.go('<');
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      splide.go('>');
    });
  }

  const playInitialVideo = () => {
    if (splide.Components) {
      playActiveVideo();
    } else {
      requestAnimationFrame(playInitialVideo);
    }
  };
  requestAnimationFrame(playInitialVideo);
}
